import wixData from 'wix-data';

let product

$w.onReady(async function () {
	product = await $w('#productPage1').getProduct();
	$w('#dataset1').setFilter(wixData.filter().eq('productID', product._id));
	let totalCount = $w('#dataset1').getTotalCount()

	if (totalCount > 0) {
		console.log("totalCount",totalCount);
		console.log("product",product);
	} else {
		// Code to run if otherwise
	}
});